import Accordion from 'components/utils/Accordion';
import Button from 'components/utils/Button';
import Icon from 'components/utils/Icon';
import Modal from 'components/utils/Modal';
import useResponsive from 'hooks/useResponsive';
import useTranslation from 'hooks/useTranslation';
import React, { useCallback, useMemo } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';

import style from './index.style';
import ModalMobile from '../../../utils/Product/ProductMobile/ModalMobile';
import { useRouterWithLang } from 'hooks/useRouterWithLang';

export default function TurnkeyCard({ plan = {}, promoPrice }) {
  const { TRANSLATIONS, locale } = useTranslation();
  const { isMobile, isTablet } = useResponsive();
  const isSmallDevice = isMobile || isTablet;
  const router = useRouterWithLang();
  const [discount, setDiscount] = useState('');
  const [text, setText] = useState('');
  const [priceDiscount, setPriceDiscount] = useState('');
  const [monthDiscount, setMonthDiscount] = useState('');
  const [descriptionUser, setDescriptionUser] = useState('');
  const PERMISSIONS = useSelector((state) => state.permissions);
  const [faqModalOpen, setFaqModalOpen] = useState(false);
  const user = useSelector((state) => state.user);
  const currencySymbol = user?.countryCode === 'US' ? '$' : '€';
  const isLoggedIn = useSelector((s) => s.isLoggedIn);

  const [openModal, setOpenModal] = useState({
    index: -1,
    type: 'tutorial',
    playing: -1,
  });
  const handleModal = useCallback(({ type, index, playing }) => {
    setOpenModal({ type, index, playing });
  }, []);

  useEffect(() => {
    if (plan?.planCode === 'droppybasic') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionBasic}`);
      setDiscount(`${TRANSLATIONS.pricing.discount.discountBasic}`);
      setText(`${TRANSLATIONS.pricing.discount.staiRisparmiandoBasic}`);
      setPriceDiscount(plan?.suggestedPrice);
      setMonthDiscount(`${TRANSLATIONS.pricing.discount.mesiInRegaloBasic}`);
    } else if (plan?.planCode === 'droppyplus') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionPlus}`);
      setDiscount(`${TRANSLATIONS.pricing.discount.discountPlus}`);
      setText(`${TRANSLATIONS.pricing.discount.staiRisparmiandoPlus}`);
      setPriceDiscount(plan?.suggestedPrice);
      setMonthDiscount(`${TRANSLATIONS.pricing.discount.mesiInRegaloPlus}`);
    } else if (plan?.planCode === 'bsocial') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionBSocial}`);
      setDiscount(`${TRANSLATIONS.pricing.discount.discountBsocial}`);
      setText(`${TRANSLATIONS.pricing.discount.staiRisparmiandoBsocial}`);
      setPriceDiscount(plan?.suggestedPrice);
      setMonthDiscount(`${TRANSLATIONS.pricing.discount.mesiInRegaloBsocial}`);
    } else if (plan?.planCode === 'droppylight') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionLight}`);
      setDiscount(`${TRANSLATIONS.pricing.discount.discountLight}`);
      setText(`${TRANSLATIONS.pricing.discount.staiRisparmiandoLight}`);
      setPriceDiscount(plan?.suggestedPrice);
      setMonthDiscount(`${TRANSLATIONS.pricing.discount.mesiInRegaloLight}`);
    } else if (plan?.planCode === 'droppystarter') {
      setDescriptionUser(`${TRANSLATIONS.pricing.descriptionBasic}`);
      setPriceDiscount(plan?.suggestedPrice);
      setText(`${TRANSLATIONS.pricing.discount.staiRisparmiandoLight}`);
    }
  }, [
    plan.code,
    plan?.planCode,
    TRANSLATIONS.pricing.descriptionBasic,
    TRANSLATIONS.pricing.descriptionPlus,
    TRANSLATIONS.pricing.descriptionBSocial,
    TRANSLATIONS.pricing.descriptionLight,
    TRANSLATIONS.pricing.discount.staiRisparmiandoBasic,
    TRANSLATIONS.pricing.discount.staiRisparmiandoPlus,
    TRANSLATIONS.pricing.discount.staiRisparmiandoLight,
    TRANSLATIONS.pricing.discount.staiRisparmiandoBsocial,
    TRANSLATIONS.pricing.discount.discountPlus,
    TRANSLATIONS.pricing.discount.discountBsocial,
    TRANSLATIONS.pricing.discount.discountLight,
    TRANSLATIONS.pricing.discount.discountBasic,
    TRANSLATIONS.pricing.discount.mesiInRegaloBasic,
    TRANSLATIONS.pricing.discount.mesiInRegaloPlus,
    TRANSLATIONS.pricing.discount.mesiInRegaloBsocial,
    TRANSLATIONS.pricing.discount.mesiInRegaloLight,
    plan?.suggestedPrice,
  ]);

  const getTitle = useMemo(() => {
    if (plan?.planCode === 'droppylight') {
      return 'File';
    } else if (plan?.planCode === 'droppybasic') {
      return 'Plugin';
    } else if (plan?.planCode === 'droppyplus') {
      return 'Plugin +';
    } else if (plan?.planCode === 'droppystarter') {
      return 'Selection';
    } else if (plan?.planCode === 'bsocial') {
      return 'Social';
    } else return plan.name;
  }, [plan]);

  const createMarkup = useMemo(
    () => ({ __html: plan?.descriptions?.[locale] }),
    [locale, plan?.descriptions]
  );

  const createMarkupSecondDescriptions = useMemo(
    () => ({ __html: plan?.secondDescriptions?.[locale] || '' }),
    [locale, plan?.secondDescriptions]
  );

  const createMarkupThirdDescriptions = useMemo(
    () => ({ __html: plan?.thirdDescriptions?.[locale] || '' }),
    [locale, plan?.thirdDescriptions]
  );

  const getDownloadFilePath = useMemo(() => {
    switch (locale) {
      case 'it_IT':
        return 'https://media.bdroppy.com/assets/esempio_xls_italiano.xlsx';
      case 'fr_FR':
        return 'https://media.bdroppy.com/assets/exemple_xls_français.xlsx';
      case 'es_ES':
        return 'https://media.bdroppy.com/assets/ejemplo_xls_español.xlsx';
      default:
        return 'https://media.bdroppy.com/assets/example_xls_english.xlsx';
    }
  }, [locale]);

  const [price, setPrice] = useState();
  const [decimalPart, setDecimalPart] = useState();

  useEffect(() => {
    const planPrice =
      plan.model === 'year'
        ? (plan?.suggestedPrice / 12).toFixed(2).toString()
        : plan?.suggestedPrice.toFixed(2).toString();
    const priceSplit = planPrice.split('.');
    setPrice(priceSplit[0]);
    setDecimalPart(priceSplit[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plan.model, price, decimalPart]);

  return (
    <div
      key={plan._id}
      index={plan.id}
      className={`pricing-card-container
            ${
              plan?.planCode === 'droppybasic'
                ? 'basic'
                : plan?.planCode === 'bsocial'
                ? 'bsocial'
                : plan?.planCode === 'droppylight'
                ? 'light'
                : 'plus'
            }`}
    >
      <Modal
        openModal={openModal?.type && openModal?.index >= 0}
        onClose={() => {
          handleModal({ type: null, index: -1, playing: -1 });
        }}
        width={`${isMobile ? '' : '600px'}`}
        positionFixed
      >
        <ReactPlayer
          width={'100%'}
          height={'70vh'}
          url={TRANSLATIONS.pricing.bsocial.socialVideoTutorial}
          playing={openModal?.playing > 0}
          controls
        />
      </Modal>
      <ModalMobile
        openModal={faqModalOpen}
        onClose={() => setFaqModalOpen(false)}
        width={`100%`}
        title="FAQ"
      >
        <div
          className={`pricing-card-accordion-content ${
            !isSmallDevice && 'faq-desktop'
          }`}
          dangerouslySetInnerHTML={createMarkupThirdDescriptions}
        />
      </ModalMobile>
      {plan.model === 'year' &&
        (plan?.planCode === 'droppybasic' ||
          plan?.planCode === 'droppyplus' ||
          plan?.planCode === 'droppystarter') &&
        plan?.streetPrice !== null && (
          <>
            <div className="pricing-card-ribbon">
              <span>{monthDiscount}</span>
            </div>
            <div className={'promo-circle'}>
              <div style={{ marginTop: 5 }}>
                <p style={{ fontSize: 22 }}>
                  -
                  {100 -
                    ((plan?.streetPrice / plan?.suggestedPrice) * 100).toFixed(
                      0
                    )}
                  %
                </p>
              </div>
            </div>
          </>
        )}
      <div
        className={`d-f fd-c pricing-wrapper-desc ${
          plan?.streetPrice !== null && 'mt-md'
        }`}
      >
        <div className="d-f ai-c jc-sb g-10">
          <span className={`pricing-card-title`}>{getTitle}</span>
          {plan?.planCode === 'droppybasic' && !promoPrice && false && (
            <div className="pricing-card-most-popular">
              <span className="pricing-card-most-popular-text">
                {TRANSLATIONS.pricing.mostPopular}
              </span>
            </div>
          )}
          {plan?.planCode === 'bsocial' && !promoPrice && false && (
            <div className="pricing-card-most-cashback">
              <span className="pricing-card-cashback-text">
                {TRANSLATIONS.pricing.cashback}
              </span>
            </div>
          )}
        </div>
        <div className={`pricing-card-title-divider`} />
      </div>
      {plan?.planCode !== 'free' && (
        <div className="pricing-card-price-container">
          {plan.model === 'year' &&
            plan?.streetPrice !== null &&
            priceDiscount !== plan?.streetPrice && (
              <p className={`d-f g-10 pricing-card-saving`}>
                <span className={`pricing-card-discount`}>
                  {priceDiscount} {currencySymbol}
                </span>
              </p>
            )}
          <span className="pricing-card-price">
            {plan?.streetPrice !== null && plan.model === 'year' ? (
              plan?.streetPrice
            ) : (
              <>
                {price}.
                <span className="pricing-card-price-decimal">
                  {decimalPart}
                </span>
              </>
            )}
          </span>{' '}
          {plan?.streetPrice !== null ? (
            <span>
              {currencySymbol} / {TRANSLATIONS.pricing.year}
            </span>
          ) : (
            <span>
              {currencySymbol} / {TRANSLATIONS.pricing.month}
            </span>
          )}
          <div className={`d-f g-5 pricing-card-saving card-pricing-sp`}>
            {plan?.size === 'year' && (
              <>
                {plan?.streetPrice !== null &&
                priceDiscount !== plan?.streetPrice ? (
                  <>
                    {text}
                    <div className="d-f g-5 pricing-card-saving">
                      <strong>
                        {(priceDiscount - plan?.streetPrice).toFixed(2)}
                        {currencySymbol}
                      </strong>
                    </div>
                  </>
                ) : (
                  <>
                    {TRANSLATIONS.pricing.billedAnnually}{' '}
                    <strong>
                      {plan?.suggestedPrice} {currencySymbol}
                    </strong>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      )}
      {plan?.planCode === 'free' && (
        <div className="pricing-card-price-container">
          <span className="pricing-card-price">
            {TRANSLATIONS.pricing.gratis}
          </span>
          <div className={`d-f g-5 pricing-card-saving card-pricing-sp`} />
        </div>
      )}
      <div className="pricing-card-divider" />
      <div className="d-f fd-c pricing-card-description">
        <div className="d-f g-10 fd-c pricing-card-description-user">
          {plan?.planCode !== 'bsocial' && plan?.planCode !== 'free' && (
            <p>{descriptionUser}</p>
          )}

          {plan?.planCode === 'droppylight' && (
            <div className={'tutorial-text'}>
              <a
                href={getDownloadFilePath}
                target="_blank"
                download
                rel="noreferrer"
              >
                <p>{TRANSLATIONS.pricing.downloadExampleFile}</p>
              </a>
            </div>
          )}
          <div
            className="pricing-card-accordion-description"
            dangerouslySetInnerHTML={createMarkup}
          />
        </div>
      </div>
      <div className="pricing-card-cta">
        {plan?.planCode !== 'free' && (
          <Button
            className={`button pricing large`}
            onClick={() => {
              if (isLoggedIn) {
                router.push(`/payment/${plan.planId}/code/${plan.code}`);
              } else {
                router.push(
                  `/register?redirectUrl=payment/${plan.planId}/code/${plan.code}`,
                  `/register`
                );
              }
            }}
            //disabled={plan?.planCode === 'bsocial' && !PERMISSIONS.IS_FREE_USER}
          >
            {' '}
            {TRANSLATIONS.pricing.buy}
            <Icon className="pricing-card-button-arrow" type="arrow-right" />
          </Button>
        )}
        {plan?.planCode === 'free' && (
          <div>{TRANSLATIONS.pricing.activePlan}</div>
        )}
      </div>
      <div className="pricing-card-divider" />

      <Accordion label={TRANSLATIONS.pricing.showMore}>
        <div
          className="pricing-card-accordion-content"
          dangerouslySetInnerHTML={createMarkupSecondDescriptions}
        />
      </Accordion>
      <div className="faq" onClick={() => setFaqModalOpen(true)}>
        FAQ
      </div>
      <style jsx>{style}</style>
    </div>
  );
}
